













































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ActivityDetails extends Vue {

    @Prop({ required: true })
    public activity!: any;

    @Prop({ required: true })
    public dialog!: boolean;

    public close() {
        this.$emit('update:dialog', !this.dialog);
    }

    public mounted() {
    }
    
}
